module.exports = __webpack_public_path__ + "img/2026.36f9ea9f.png";